import React from "react";
import Input from "../../../../../components/FormComponents/Input";
import Label from "../../../../../components/FormComponents/Label";
import { getLabelForKey } from "../../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditSlider = (props) => {
  const { editFieldData, setEditFieldData } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        type="number"
        label={getLabelForKey("default_value")}
        value={editFieldData.default_value}
        name="default_value"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <Input
        type="checkbox"
        label={getLabelForKey("backend_validation")}
        checked={editFieldData.validate.backend_validation}
        name="backend_validation"
        size="medium"
        containerClassName="w_50"
        onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
      />
      <div className="d_flex gap_2">
        <div className="w_50">
          <Label>Slider range</Label>
          <div className="flex_row gap_2">
            <div>
              <Input
                type="number"
                value={editFieldData.slider_min}
                name="slider_min"
                onChange={({ target }) => handleChangeInput(target.name, target.value)}
              />
              <span>Start</span>
            </div>
            <div>
              <Input
                type="number"
                value={editFieldData.slider_max}
                name="slider_max"
                onChange={({ target }) => handleChangeInput(target.name, target.value)}
              />
              <span>End</span>
            </div>
          </div>
        </div>
        <div className="w_50">
          <Label>Slider steps</Label>
          <div className="flex_row gap_2">
            <div>
              <Input
                type="number"
                value={editFieldData.slider_step}
                name="slider_step"
                onChange={({ target }) => handleChangeInput(target.name, target.value)}
              />
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditSlider;
